import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '@/store/hooks';
import { CalendarGranularity, RuleWorkspaceView } from '@/store/slices/ruleCalendarSlice';
const initialRuleCalendarState = {
    view: RuleWorkspaceView.Table,
    granularity: CalendarGranularity.Month,
    anchorDate: 0,
};
// Base selector to get rule-calendar state from Redux store
export const ruleCalendarStateSelector = (state) => { var _a; return (_a = state.ruleCalendar) !== null && _a !== void 0 ? _a : initialRuleCalendarState; };
export const ruleWorkspaceViewSelector = createSelector([ruleCalendarStateSelector], (ruleCalendarState) => ruleCalendarState.view);
export const calendarGranularitySelector = createSelector([ruleCalendarStateSelector], (ruleCalendarState) => ruleCalendarState.granularity);
export const calendarAnchorDateSelector = createSelector([ruleCalendarStateSelector], (ruleCalendarState) => ruleCalendarState.anchorDate);
// Hook to get the current rule workspace view (Table vs Calendar)
export const useRuleWorkspaceViewSelector = () => useAppSelector(ruleWorkspaceViewSelector);
export const useCalendarGranularitySelector = () => useAppSelector(calendarGranularitySelector);
export const useCalendarAnchorDateSelector = () => useAppSelector(calendarAnchorDateSelector);
